// extracted by mini-css-extract-plugin
export default {"wrapper":"TableEventsTools_wrapper__yKWP8","categories":"TableEventsTools_categories__O6s+f"};